<div class="row">
  <div class="col-md-12">
    <h5>Documents</h5>
    <div class="btn-group" *ngIf="!isInsurer">
      <button (click)="openDocumentsPopup(content)"
          class="btn btn-success btn-sm">Add Document</button> 
          <!-- Hide Regenrate Schedule if quote is inprogress and referred -->
      <button 
        (click)="regenerate_schedule(reSchedule)" 
        *ngIf="quote && quote.insurance_status_id != 'e216564f-552a-4e45-ae67-0a63b7074691' && quote.insurance_status_id != 'f6d14624-6351-4d93-b27b-70fb8a06ec5d'" 
        class="btn btn-gray text-white btn-sm"
      >
        Regenerate Schedule
      </button>
  </div>
  </div>
</div>
<div class="row mt-3" *ngIf="loading">
  <div class="col-md-12">
    <p class="text-muted">Loading documents...</p>
  </div>
</div>
<div class="row mt-3" *ngIf="!loading && rowData.length === 0">
  <div class="col-md-12">
    <p class="text-muted">No documents for this quote.</p>
  </div>
</div>
<div class="row mt-3" *ngIf="!loading && rowData.length > 0">
  <div class="col-md-12">
    <div class="form_sections">
      <h5>Peliwica Documents</h5>
      <table class="table table-sm table-bordered">
        <thead>
          <tr>
            <th>Document Type</th>
            <th>Document Name</th>
            <th>Date</th>
            <th style="width: 100px;" class="text-right">Download</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of rowData">
            <td>{{ doc.document_type_label || doc.document_type || '—' }}</td>
            <td>{{ doc.title || doc.document_title || doc.name || '—' }}</td>
            <td>{{ (doc.created_at || doc.created_date) | date:'dd/MM/yyyy HH:mm' }}</td>
            <td class="text-right">
              <button type="button" class="btn btn-link btn-sm p-0" title="Download Document" (click)="downloadDoc(doc)">
                <i class="mdi mdi-cloud-download" style="font-size: 18px; color: #138a51;"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<ng-template #content let-modal>
  <div class="modal-header">
      <h4>Document</h4>
  </div>
  <div class="modal-body">
      <div class="form-group">
          <label>Title</label>
          <input type="text" name="document_title" [(ngModel)]="docTitle" class="form-control form-control-sm">
      </div>
      <div class="form-group" *ngIf="!documentsEditMode">
          <label>Document</label>
          <div class="custom-file">
              <input type="file" name="file_name" (change)="getUploadedFile($event.target.files)"
                  class="custom-file-input" id="customFile">
              <label class="custom-file-label" for="customFile">{{quote.quote_document}}</label>
          </div>
      </div>
  </div>
  <div class="modal-footer">
      <button type="button" *ngIf="!documentsEditMode" class="btn btn-success"
          (click)="documentUpload()">Upload</button>
      <button type="button" *ngIf="documentsEditMode" class="btn btn-success"
          (click)="updateDocument()">Update</button>
      <button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button>
  </div>
</ng-template>
<ng-template #documentsDelete let-modal>
  <div class="modal-header">
      <h4>Delete Document</h4>
  </div>
  <div class="modal-body text-center">
      <img src="assets/images/deactivate.png" width="50"><br>
      Are you sure you want to delete document {{docTitle}}?
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="deleteDocument()">Yes</button>
      <button type="button" class="btn btn-default" (click)="modal.close()">No</button>
  </div>
</ng-template>
<ng-template #reSchedule let-modal>
  <div class="modal-body">
      {{schMsg}}
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="modal.close()">OK</button>
  </div>
</ng-template>
<ng-template #vetCert let-modal>
  <div class="modal-body">
      <p [ngStyle]="{'color': certMsgStyle?'#138a51':'red'}">{{vetCertMsg}}</p>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="submit_vet_certificate()">Yes</button>
      <button type="button" class="btn btn-default" (click)="modal.close()">No</button>
  </div>
</ng-template>